import React from "react";
import { usePhoneInventoryStore } from "../../../stores/usePhoneInventoryStore";
import { useParams } from "react-router-dom";
import EmptyStateView from "../../EmptyStateView";

export default function PhoneInventoryEmptyState() {
  const { openPurchaseNumberPanel } = usePhoneInventoryStore();
  const { workspaceSlug } = useParams();

  const handleAddNumber = () => {
    openPurchaseNumberPanel("inventory", {
      returnTo: "inventory",
      workspaceSlug: workspaceSlug,
      sourceComponent: "phone-inventory-empty-state",
    });
  };

  return <EmptyStateView buttonText="Add New Number" onButtonClick={handleAddNumber} />;
}
